import { Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@ngneat/transloco';
import { ApiService } from '../services/api/api.service';
import { Company } from '../interfaces/Company';
import { CompanyResponse } from '../interfaces/CompanyResponse';
import { GlobalConstants } from '../common/global-constants';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-reports',
    standalone: true,
    imports: [
        MatButtonModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
        TranslocoModule,
        NgFor,
    ],
    templateUrl: './reports.component.html',
    styleUrl: './reports.component.scss',
})
export class ReportsComponent {
    // Array of companies
    companies: Company[] = [];

    selectedCompany: string = '';

    selectedReport: string = '';

    specialist = GlobalConstants.specialist;

    internal = GlobalConstants.internal;

    constructor(private apiService: ApiService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for role name
     */
    get roleName(): string {
        return localStorage.getItem('roleName') ?? '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * ngOnInit
     */
    ngOnInit() {
        if (this.roleName == GlobalConstants.internal) {
            this.apiService
                .getCompanyPagination(0, 1000000, 'name', 'asc')
                .subscribe((response: CompanyResponse) => {
                    this.companies.push(...response.companies);
                });
        }
    }

    // Show empty state
    showEmptyState() {
        this.selectedReport = '';
    }

    // Change company
    changeCompany() {
        this.showEmptyState();
    }

    downloadPdf() {
        this.apiService
            .getVulnerabilityReport(
                'pdf',
                this.roleName == GlobalConstants.internal
                    ? this.selectedCompany
                    : ''
            )
            .subscribe((blob) => {
                const filename = this.selectedReport + '.pdf';
                saveAs(blob, filename);
            });
    }

    downloadExcel() {
        this.apiService
            .getVulnerabilityReport(
                'excel',
                this.roleName == GlobalConstants.internal
                    ? this.selectedCompany
                    : ''
            )
            .subscribe((blob) => {
                const filename = this.selectedReport + '.xlsx';
                saveAs(blob, filename);
            });
    }
}
